import styled from '@emotion/styled';
import { Document, Page } from 'react-pdf';
import Input from 'tradevan-ui/Input';

export const PDFReaderDivStyled = styled.div({
  margin: '0 auto',
  height: '100vh',
});

export const ControlPanelStyled = styled.div({
  display: 'flex',
  padding: '10px',
  backgroundColor: 'white',
  boxSizing: 'border-box',
  marginTop: '10px',
  borderRadius: '10px',
  flexWrap: 'wrap',
  width: 'fit-content',
  margin: '0 auto',
});

export const DocumentStyled = styled(Document)({
  display: 'block',
  marginTop: '10px',
});
export const PageStyled = styled(Page)({
  overflow: 'auto',
  maxWidth: '100vw',
  height: 'calc(100vh - 78px)',
});

export const InputNumberStyled = styled(Input)({
  margin: '0 5px',
  fontSize: '18px',
  width: '4rem !important',
  '& input': {
    textAlign: 'center',
  },
});

export const FlexStyled = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
});
export const GapStyled = styled.div({
  margin: '5px',
});
